import React, {useEffect} from 'react';

import {RouterController} from "./router-controller";
import {BaseMatchModel} from "./models/base-match-model";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {RouteModel} from "./models/route-model";
import {HISTORY_ACTIONS} from "../../consts";
import {AppStore} from "../../app/app-store";
import {WithRouter} from "./with-router";
import {useNavigationType} from "react-router-dom";

export const RouteComposer = (routerProps, route: RouteModel) => WithRouter(route)(({match, ...rest}) => {
    const navigationType = useNavigationType();

    const onRouteChange = (match: BaseMatchModel) => {
      const matchModel: BaseMatchModel = match;

      const appStore: AppStore = routerProps.ioc.getInstance(AppStore);
      const domUtils: DomUtils = routerProps.ioc.getInstance(DomUtils);
      const routerController: RouterController = routerProps.ioc.getInstance(RouterController);
      const currentRoute: RouteModel = routerController.getCurrentRoute(matchModel);

      if (!currentRoute) {
        return;
      }

      const shouldScrollToTop: Boolean = navigationType !== HISTORY_ACTIONS.pop && !currentRoute.isSubRoute;
      if (shouldScrollToTop) {
        const isWidget: Boolean = appStore.state.settings.isWidget;
        domUtils.scrollToTop(isWidget);
      }

      routerController.handleMatchChange(matchModel);
      routerController.onRouteChange(currentRoute);
      routerProps.onChange && routerProps.onChange(currentRoute);
    }

    useEffect(() => {
      onRouteChange(match);
      routerProps.onRouteLoaded?.();
    }, [match?.url, match?.hashParams?.toString()]);

    return <route.config.component {...routerProps} {...rest} match={match}/>
  }
);
